// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breadcrumbs":"css-a9baeygfaY","breadcrumbs_inner_links":"css-1JGkwyqG7A","breadcrumbs_inner_link":"css-2IfOlQidP7","breadcrumbs__productPage":"css-s13Jwjm_5p"};